/* TRH: "Available in N colorways" on Rapid Search product cards (2026-10-28).
   Rapid Search's "Theme original" card snapshot drops the Liquid-computed count line
   from snippets/card-product.liquid, so we add it back client-side. */
(function () {
  if (window.__trhCwc) return; window.__trhCwc = true;
  var NAMES = ['color','colour','colorway','colourway','colors','colours','colorways','colourways'];
  var TPL = window.trhColorwaysText || 'Available in __N__ colorways';
  var KEY = 'trhCwc1', cache = {};
  try { cache = JSON.parse(sessionStorage.getItem(KEY) || '{}') || {}; } catch (e) { cache = {}; }
  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(cache)); } catch (e) {} }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var pending = {}, queue = [], active = 0, MAX = 6;
  function pump() {
    while (active < MAX && queue.length) {
      (function (h) {
        active++;
        fetch(root + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            var n = 0;
            if (p && p.options) for (var i = 0; i < p.options.length; i++) {
              var o = p.options[i], nm = String((o && o.name) || '').trim().toLowerCase();
              if (NAMES.indexOf(nm) > -1) { n = (o.values || []).length; break; }
            }
            cache[h] = n; save(); return n;
          })
          .catch(function () { return 0; })
          .then(function (n) {
            active--; var cbs = pending[h] || []; delete pending[h];
            cbs.forEach(function (f) { f(n); }); pump();
          });
      })(queue.shift());
    }
  }
  function getCount(h, cb) {
    if (Object.prototype.hasOwnProperty.call(cache, h)) return cb(cache[h]);
    if (pending[h]) return pending[h].push(cb);
    pending[h] = [cb]; queue.push(h); pump();
  }
  function handleOf(a) {
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function processCard(card) {
    if (card.getAttribute('data-trh-cwc') || card.querySelector('.product-card-color-count')) return;
    var a = card.querySelector('a[href*="/products/"]'); if (!a) return;
    var h = handleOf(a); if (!h) return;
    card.setAttribute('data-trh-cwc', '1');
    getCount(h, function (n) {
      if (n < 2 || card.querySelector('.product-card-color-count')) return;
      var infos = card.querySelectorAll('.card-information');
      var info = infos[infos.length - 1]; if (!info) return;
      var p = document.createElement('p');
      p.className = 'product-card-color-count';
      p.textContent = TPL.replace('__N__', n);
      var price = info.querySelector('.price');
      if (price && price.parentNode === info) info.insertBefore(p, price); else info.appendChild(p);
    });
  }
  function scan() {
    var cards = document.querySelectorAll('.rps-results .card-wrapper');
    for (var i = 0; i < cards.length; i++) processCard(cards[i]);
  }
  var t = null;
  function soon() { if (t) return; t = setTimeout(function () { t = null; scan(); }, 150); }
  function start() {
    scan();
    new MutationObserver(soon).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
